import Messages from './Messages';
import { bindActionCreators } from 'redux';
import withStyles from 'react-jss';
import styles from './styles';
var mapStateToProps = function (state) {
};
var mapDispatchToProps = function (dispatch) {
    return bindActionCreators({}, dispatch);
};
export default withStyles(styles)(Messages); // connect(mapStateToProps ,mapDispatchToProps)(withStyles(styles)(Messages));



//////////////////
// WEBPACK FOOTER
// ./src/components/Messages/index.tsx
// module id = 811
// module chunks = 0